const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  carts: [],
};

const { actions, reducer } = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => ({
      ...state,
      carts: action.payload,
    }),
  },
});

export default reducer;

export const { setCart } = actions;

// ----------------------------------------------------------------------

export const getCart = (userId) => async (dispatch) => {
  try {
    let storageCart = localStorage.getItem(`cart_${userId}`);

    if (storageCart) {
      storageCart = JSON.parse(storageCart);
    }

    dispatch(setCart(storageCart));
  } catch (err) {
    console.log(err);
  }
};

// ----------------------------------------------------------------------
